




















































































































































import Vue from 'vue';

// Services
import AnalyticService from '~/services/AnalyticService';
import AonContext, {
    InstrumentData,
    InstrumentStatus,
    INSTRUMENTS_PREMIUM,
    SAMPLE_REPORT_URL,
} from '~/services/AonContext';

// Components
import AssessmentButton from './AssessmentButton.vue';
import AssessmentInstrumentListItem from './AssessmentInstrumentListItem.vue';

// Assets
import businessSuccess from '~/assets/img/aon/business-success.png';
import cyberspace from '~/assets/img/aon/cyberspace.png';
import StripePaymentPng from '~/assets/img/stripe-payment.png';

// Constants
import URLS from '~/URLS';

export default Vue.extend({
    name: 'AssessmentCard',
    components: { AssessmentButton, AssessmentInstrumentListItem },
    props: {
        isLoading: Boolean,
        context: {
            type: Object as () => AonContext,
            default: () => ({} as AonContext),
        },
        premium: Boolean,
        progressMode: Boolean, // Makes the component show the progress of each instrument
    },
    data() {
        return {
            SAMPLE_REPORT_URL: SAMPLE_REPORT_URL,
            isOpen: this.progressMode,
            sampleReport:
                'https://ws01.maptq.com/ws/ws_req.aspx?reqid=4F31D19B-37B6-4796-BBC9-2BB4ECF25492',
            stripePaymentPng: StripePaymentPng,
            businessSuccess: businessSuccess,
            cyberspace: cyberspace,
        };
    },
    computed: {
        hasPremium(): boolean {
            return Boolean(this.context && this.context.hasPremium);
        },
        hasConsented(): boolean {
            return Boolean(this.context && this.context.hasConsented);
        },
        mode(): string {
            return this.premium ? 'premium' : 'freemium';
        },
        premiumPrice(): number {
            return this.$interfaces.assessmentModule.getAonProductPrice();
        },
        instrumentData(): InstrumentData[] {
            return (!this.premium ? [721, 344, 383] : INSTRUMENTS_PREMIUM.slice(1)).map(
                (instr: number) => ({
                    id: instr as number,
                    name: this.$t(`assessments.center.instruments.${instr}.name`) as string,
                    description: this.$t(
                        `assessments.center.instruments.${instr}.description`
                    ) as string,
                    estimatedTime: Number.parseInt(
                        this.$t(`assessments.center.instruments.${instr}.estimatedTime`) as string
                    ) as number,
                    status: this.context
                        ? this.context.getInstrumentStatus(instr, this.premium)
                        : InstrumentStatus.UNKNOWN,
                })
            );
        },
        numCompletedInstruments(): number {
            return this.instrumentData.filter(instr => instr.status === InstrumentStatus.COMPLETE)
                .length;
        },
        numStartedInstruments(): number {
            return this.instrumentData.filter(instr => instr.status >= InstrumentStatus.IN_PROGRESS)
                .length;
        },
        instrumentsCompleted(): boolean {
            return (
                this.instrumentData.filter(instr => instr.status == InstrumentStatus.COMPLETE)
                    .length >= 3
            );
        },
    },
    methods: {
        toggleExpanded() {
            this.isOpen = !this.isOpen;
        },
        initializeProgressMode() {
            this.context.refresh({});
        },
        goToAssessmentCenter() {
            this.$router.push(URLS.assessments.concat(URLS.assessmentCenter));
        },
        openTest() {
            AnalyticService.assessmentActionClick(this.premium, this.hasPremium, true);
            if (this.premium) {
                this.context.openPremium();
            } else {
                this.context.openFreemium();
            }
        },
        showPremiumReport() {
            if (this.premium) {
                this.context.openPremiumReport();
            }
        },
    },
    watch: {
        progressMode(newValue, oldValue) {
            if (newValue) {
                this.initializeProgressMode();
            }
        },
    },
});
